const APPLICATION_SERVER_KEY = 'BBhuoRpAL2_Wnn4tv1gsMZ5_qhsRPpeh5Hpq2GRiU6nf9YN_x_mvVSSDQtXAJN9SWQWvPD2l-ehOzwXPoEIaHOU';

export async function subscribeUser() {
  if (!("serviceWorker" in navigator) || !("PushManager" in window)) {
    alert("Push notifications are not supported in this browser.");
    return null;
  }

  try {
    const permission = await Notification.requestPermission();
    if (permission !== "granted") {
      console.log("Permission not granted for notifications.");
      return null;
    }

    const registration = await navigator.serviceWorker.ready;
    const subscription = await registration.pushManager.subscribe({
      userVisibleOnly: true,
      applicationServerKey: urlBase64ToUint8Array(APPLICATION_SERVER_KEY)
    });

    return subscription;
  } catch (error) {
    console.error("Failed to subscribe user to push notifications.", error);
    throw error;
  }
}

function urlBase64ToUint8Array(base64String) {
  const padding = "=".repeat((4 - base64String.length % 4) % 4);
  const base64 = (base64String + padding)
    .replace(/-/g, "+")
    .replace(/_/g, "/");

  const rawData = atob(base64);
  const outputArray = new Uint8Array(rawData.length);

  for (let i = 0; i < rawData.length; ++i) {
    outputArray[i] = rawData.charCodeAt(i);
  }
  return outputArray;
}